import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, from, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SESSION_PROVIDER } from '../auth/session-provider';

/** A Rock App the current user can access, as returned by Identity's /api/me/apps. */
export interface RockApp {
  id: string;
  key: string;
  name: string;
  launchUrl: string;
  description?: string | null;
  icon?: string | null;
  roles: string[];
  isDefault: boolean;
}

/**
 * Fetches the current user's accessible Rock Apps from Identity for the header switcher.
 *
 * This calls the Identity authority (not the Checkins API), so the auth interceptor — which only
 * tokens calls to the Checkins API — does not apply; we attach the bearer token ourselves.
 */
@Injectable({ providedIn: 'root' })
export class RockAppsService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(SESSION_PROVIDER);

  /** Lists the Rock Apps the signed-in user has access to. */
  myApps(): Observable<RockApp[]> {
    return from(this.session.getValidAccessToken()).pipe(
      switchMap(token => this.http.get<RockApp[]>(
        `${environment.auth.authority}/api/me/apps`,
        token !== null ? { headers: { Authorization: `Bearer ${token}` } } : {})),
    );
  }
}
